import React, { useEffect, useRef, useState } from "react";
import editInput from "../../../helpers/Inputs/editInput";
import safeUpdateFunction from "../../../helpers/Inputs/safeUpdateFunction";

import "../../../assets/css/inputs/input-main.css";

const InputEmailComp = ({name, className, id, metaData, onChange, value, updateFunction, field, maxLength, minLength, required, readonly, placeholder, form}) => {

     // How to use
    /*
        name - string
        className - string
        id - string
        metaData - object
        onChange - fn
        value - string
        updateFunction - fn
        field - string
        maxLength - num
        minLength - num
        required - bool
        readOnly - bool
        placeholder - string
        form - string
        
    */


    const [currentValue, setCurrentValue] = useState(value || "");
    const firstRender = useRef(true);

    useEffect(() => {
        if(!value) {
            safeUpdateFunction(null, currentValue, updateFunction, field);
        }

        if(firstRender.current){
            firstRender.current = false;
        }
    }, []);

    useEffect(() => {
        if(!firstRender.current) {
            if(typeof value === "string" && currentValue !== value) {
                setCurrentValue(value);
            }
        }
    }, [value])
    
    return (
        <>
            <input 
                type="email" 
                name={name || ""} 
                className={"input-base " + className || ""} 
                id={id || ""}  
                {...metaData || undefined}
                onChange={(e) => {
                    editInput(e, onChange, field, updateFunction, setCurrentValue);
                }}
                value={currentValue || ""}
                maxLength={maxLength || undefined}
                minLength={minLength || undefined}
                required={required || false}
                readOnly={readonly || false}
                placeholder={placeholder || ""}
                form={form || ""}
            />
        </>
    );
};

export default InputEmailComp;